import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class FilesUploadService {
  
  constructor (
    private http: Http
  ) {}
 
  uploadFile(data: any) {
    return this.http.post(`${CONFIGURATION.baseFileUploadURL}file/upload`,data)
    .map((res:Response) => res.json());
  }
  getFiles(data: any) {
    return this.http.post(`${CONFIGURATION.baseFileUploadURL}file/files`,data)
    .map((res:Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/fileupload/fileupload.service.ts